var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroller w-auto stock-items-list"},_vm._l((_vm.stockProducts),function(item){return _c('Product',{staticClass:"m-0",attrs:{"stock":item},on:{"click":function($event){return _vm.addToSale(item)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }